module.exports = __webpack_public_path__ + "static/media/event-languages.a555f2b7.png";